import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from '../services/session-service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private sessionService: SessionService,
        private auth: AuthService
    ) { }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.auth.getToken();

        // Caller already set Bearer (e.g. form-pdf-view with ?token=). API URLs are not
        // /form-pdf/..., so we must not replace that header with the session token.
        const hasExplicitAuthorization = request.headers.has('Authorization');

        let authRequest = request;

        if (token && !hasExplicitAuthorization) {
            authRequest = request.clone({
                setHeaders: { Authorization: `Bearer ${token}` }
            });
        }

        return next.handle(authRequest).pipe(
            catchError((error: HttpErrorResponse) => {
                // 401 on a request that used ?token= is not a logged-in session expiry
                if ((error.status === 401 ) && token && !hasExplicitAuthorization) {
                    this.sessionService.notifySessionExpired();
                }
                return throwError(() => error);
            })
        );
    }
}